module.exports = __webpack_public_path__ + "static/media/agregar-usuario.bc05506f.png";